import tippy, { Instance } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import type { Directive, DirectiveBinding } from 'vue';

interface TooltipElement extends HTMLElement {
  _geoTooltipInstance?: Instance;
}

export const GeoTooltip: Directive<TooltipElement, string | undefined | null> = {
  mounted(el: TooltipElement, binding: DirectiveBinding<string | undefined | null>) {
    const content = binding.value;
    if (!content) return;

    el._geoTooltipInstance = tippy(el, {
      content,
      placement: 'top',
      allowHTML: true
    });
  },

  updated(el: TooltipElement, binding: DirectiveBinding<string | undefined | null>) {
    const content = binding.value;

    if (el._geoTooltipInstance) {
      if (!content) {
        el._geoTooltipInstance.destroy();
        el._geoTooltipInstance = undefined;
      } else {
        el._geoTooltipInstance.setContent(content);
      }
    } else if (content) {
      el._geoTooltipInstance = tippy(el, {
        content,
        placement: 'top',
        allowHTML: true
      });
    }
  },

  beforeUnmount(el: TooltipElement) {
    if (el._geoTooltipInstance) {
      el._geoTooltipInstance.destroy();
      el._geoTooltipInstance = undefined;
    }
  }
};
